import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'HT_TRENDLINE',
  version: 1,
  label: 'Hilbert Instantaneous Trendline',
  pane: 'main',
  category: 'cycles',
  series: 'price',
  order: 10,
  inputs: [],
  outputs: [line('trendline', 'Trendline', COLOR.blue)],
  talib: { functions: ['HT_TRENDLINE'], expr: 'HT_TRENDLINE(close)' },
  listed: true,
  tailSafe: true,
  // TA_HT_TRENDLINE_Lookback: 32 for the Hilbert engine + 31 "to be compatible with Tradestation".
  lookback: () => 63,
}
export default def
